import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Services.scss';

import logoPatte from '../../assets/img/logo-patte-removebg-preview.png';
import imgchien1 from '../../assets/img/chien2.jpg';
import imgchien2 from '../../assets/img/chien3.jpg';
import imgchien3 from '../../assets/img/chien4.jpg';
import imgchien4 from '../../assets/img/galerie/galerieImg33.jpeg';

function Services() {
    const location = useLocation();
    const serviceType = location.state?.service;

    useEffect(() => {
        if (serviceType) {
            const element = document.getElementById(serviceType);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [serviceType]);

    const scrollToService = (serviceId) => {
        const element = document.getElementById(serviceId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <main className="services-container">
            <div className="service-background">
                <div className="service-background__container-title">
                    <p className="service-background__title">La Truffe à 4 Pattes</p>
                    <img className="service-background__logo" src={logoPatte} alt="Logo" />
                </div>
            </div>
            <section className="services__content">
                <h1 className="services__main-title">Nos Services</h1>
                <div className="services__navigation">
                    <button onClick={() => scrollToService('education')}>Éducation Canine</button>
                    <button onClick={() => scrollToService('petsitter')}>Pet-Sitting</button>
                    <button onClick={() => scrollToService('promenade')}>Promenades</button>
                    <button onClick={() => scrollToService('visite')}>Visites à Domicile</button>
                </div>
                <div className="services__grid">
                    <div id='education' className={`services__grid-item services__grid-item--education ${serviceType === 'education' ? 'highlighted-service' : ''}`}>
                        <div className="services__header-img services__header-img--education" />
                        <h2 className="services__item-title">Éducation Canine</h2>
                        <ul className='services__list'>
                            <li className='service__text'>Renforce le lien entre le chien et son propriétaire.</li>
                            <li className='service__text'>Améliore la communication et la compréhension.</li>
                            <li className='service__text'>Contribue au bien-être mental du chien.</li>
                            <li className='service__-text'>Aide à la socialisation et à l'adaptation.</li>
                            <li className='service__text'>Encourage un comportement positif.</li>
                            <li className='service__text'>Fournit une routine structurée.</li>
                        </ul>
                        <div className="services__tarif">
                            <h3 className="services__tarif-title">Tarifs</h3>
                            <div className="services__flex">
                                <ul className="services__container-text">
                                    <li className="services__tarif-text">Etude de comportement: 40€ - <span>Entre 1h et 1h30</span></li>
                                    <li className="services__tarif-text">Séance d'éducation: 45€ - <span>1h</span></li>
                                    <li className="services__tarif-text">Séance collective: 25€ - <span>Minimum 3 chiens</span></li>
                                    <li className="services__tarif-text">Pour un contrat de 5 séances minimum signé <span>une balade educative offerte</span></li>
                                </ul>
                                <div className="services__container-img">
                                    <img className="services__img" src={imgchien1} alt="Education" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="services__grid-item services__grid-item--petsitter">
                        <div id='petsitter' className="services__header-img services__header-img--petsitter" />
                        <h2 className="services__item-title">Pet-Sitting à Mon Domicile</h2>
                        <ul className='services__list'>
                            <li className='service__text'>Offre un environnement sécurisé et attentionné.</li>
                            <li className='service__text'>Assure la continuité des routines quotidiennes.</li>
                            <li className='service__text'>Permet la socialisation avec d'autres animaux.</li>
                            <li className='service__text'>Suivi personnalisé des besoins spécifiques.</li>
                            <li className='service__text'>Alternative confortable au chenil.</li>
                        </ul>
                        <div className="services__tarif">
                            <h3 className="services__tarif-title">Tarifs</h3>
                            <div className="services__flex">
                                <ul className="services__container-text">
                                    <li className="services__tarif-text">Journée: 20€ / férié (+5€) <span></span></li>
                                    <li className="services__tarif-text">Journée + Nuit: 28€ <span></span></li>
                                    <li className="services__tarif-text">1 Semaine: 165€ <span></span></li>
                                    <li className="services__tarif-text">2 Semaines: 300€ <span></span></li>
                                    <li className="services__tarif-text">3 Semaines: 430€ <span></span></li>
                                    <li className="services__tarif-text">1 Week-End: 50€ <span></span></li>
                                </ul>
                                <div className="services__container-img">
                                    <img className="services__img" src={imgchien2} alt="Petsitter" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="services__grid-item services__grid-item--promenades">
                        <div id='promenade' className="services__header-img services__header-img--promenades" />
                        <h2 className="services__item-title">Promenades</h2>
                        <ul className='services__list'>
                            <li className='service__text'>Garantit une activité physique régulière.</li>
                            <li className='service__text'>Stimule mentalement le chien.</li>
                            <li className='service__text'>Encourage la socialisation.</li>
                            <li className='service__text'>Aide à dissiper l'énergie excessive.</li>
                            <li className='service__text'>Surveillance régulière de la santé du chien.</li>
                        </ul>
                        <div className="services__tarif">
                            <h3 className="services__tarif-title">Tarifs</h3>
                            <div className="services__flex">
                                <ul className="services__container-text">
                                    <li className="services__tarif-text">1 Promenade: 15€ <span>45min/1h</span></li>
                                </ul>
                                <div className="services__container-img">
                                    <img className="services__img" src={imgchien3} alt="Promenade" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="services__grid-item services__grid-item--visites">
                        <div id='visite' className="services__header-img services__header-img--visites" />
                        <h2 className="services__item-title">Visites à Domicile</h2>
                        <ul className='services__list'>
                            <li className='service__text'>Maintient les chiens dans leur environnement familier.</li>
                            <li className='service__text'>Suivi personnalisé des routines habituelles.</li>
                            <li className='service__text'>Offre une compagnie et une attention individuelle.</li>
                            <li className='service__text'>Assure une surveillance régulière de la santé.</li>
                            <li className='service__text'>Tranquillité d'esprit pour les propriétaires.</li>
                        </ul>
                        <div className="services__tarif">
                            <h3 className="services__tarif-title">Tarifs</h3>
                            <div className="services__flex">
                                <ul className="services__container-text">
                                    <li className="services__tarif-text">1 Visite pour Chien: 10€ <span></span></li>
                                    <li className="services__tarif-text">1 Passage pour Chat: 10€ <span>par jour</span></li>
                                    <li className="services__tarif-text">2 Passages pour Chat: 15€<span></span></li>
                                    <li className="services__tarif-text">1 Semaine pour Chat: 60€ / 85€<span></span></li>
                                    <li className="services__tarif-text">2 Semaines pour Chat: 115€ / 165€<span></span></li>
                                    <li className="services__tarif-text">3 Semaines pour Chat: 175€ / 245€<span></span></li>
                                </ul>
                                <div className="services__container-img">
                                    <img className="services__img" src={imgchien4} alt="Visite" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default Services;

